<template>
  <v-form
    fast-fail
    @submit.prevent="saveData"
    class="edit-user"
    v-click-outside="cancelAction"
  >
    <h2 class="title mb-2">{{ $t("users.table.createUserModal.title") }}</h2>
    <v-text-field
      v-model="userData.email"
      :label="$t('profile.email')"
      autocomplete="new-user"
    ></v-text-field>
    <v-text-field
      type="password"
      v-model="userData.password"
      :label="$t('profile.password')"
      autocomplete="new-password"
    >
      <template v-slot:append-inner>
        <v-tooltip :text="$t('users.table.modals.passwordTooltip')">
          <template v-slot:activator="{ props }">
            <v-icon v-bind="props" icon="$info" class="pb-1"></v-icon>
          </template>
        </v-tooltip>
      </template>
    </v-text-field>

    <v-select
      :label="$t('users.table.createUserModal.role')"
      :items="roles"
      item-title="value"
      item-value="key"
      v-model="userData.role"
    ></v-select>
    <v-select
      v-if="userData.role == 1"
      :label="$t('users.table.editModal.partner')"
      :items="this.partners"
      item-title="name"
      item-value="id"
      v-model="userData.partner"
    ></v-select>
    <div class="btn-row mt-6">
      <v-btn @click="cancelAction">
        {{ $t("profile.cancel") }}
      </v-btn>
      <v-btn :disabled="!visibleButton" color="primary" @click="createUser">
        {{ $t("profile.save") }}
      </v-btn>
    </div>
  </v-form>
</template>

<script>
import { roleEnums } from "@/components/enums";
import { mapActions } from "vuex";

export default {
  name: "CreateUserModal",
  props: {},
  data() {
    return {
      userData: {
        email: "",
        password: "",
        role: undefined,
        partner: undefined,
      },
      partners: [],
      roles: [],
    };
  },
  created() {
    this.getPartnerList();
    this.setRoles();
  },
  methods: {
    ...mapActions({
      getPartners: "users/getPartners",
    }),
    setRoles() {
      roleEnums.map((role) => {
        const currentRole = {
          key: role.key,
          value: this.$t(`enums.role.${role.value}`),
        };
        this.roles.push(currentRole);
      });
    },
    getPartnerList() {
      this.getPartners()
        .then((response) => {
          this.partners = response.result.map((partner) => {
            return { id: partner.id, name: partner.par_name };
          });
        })
        .catch(() => {});
    },
    cancelAction() {
      if (document.activeElement.tagName != "INPUT") {
        this.emitter.emit("closeModal");
      }
    },
    createUser() {
      const createPayload = {
        email: this.userData.email,
        password: this.userData.password,
        role: this.userData.role,
        par_id: this.userData.role === 1 ? this.userData.partner : null,
      };
      this.$emit("createNewUser", createPayload);
      this.emitter.emit("closeModal");
    },
  },
  computed: {
    visibleButton() {
      return (
        this.userData.email !== "" &&
        this.userData.password !== "" &&
        this.userData.password.length >= 6 &&
        this.userData.role !== undefined &&
        !(this.userData.role === 1 && this.userData.partner === undefined)
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-user {
  min-width: 400px;
  padding: 24px;
  @media (max-width: 520px) {
    min-width: 300px;
    padding: 12px;
  }
  .btn-row {
    display: flex;
    justify-content: space-between;
    @media (max-width: 520px) {
      flex-direction: column;
      gap: 12px;
    }
  }
}
</style>
